import { useState } from 'react';

/**
 * Hook für das State-Management der Map-Komponente
 * Verwaltet Layer-Visibility
 */
export const useMapState = () => {
  const [layerVisibility, setLayerVisibility] = useState({
    windenergieanlagen: true,
    land_parcels: true,
  });

  const toggleLayer = (layerName: keyof typeof layerVisibility) => {
    setLayerVisibility(prev => ({
      ...prev,
      [layerName]: !prev[layerName]
    }));
  };

  return {
    layerVisibility,
    toggleLayer,
  };
};
